export var TITLE = 'MoonshotAI';
export var TEXT_MULTIPLE = 0.75;
export var SPACE_MULTIPLE = 0.4;
export var COLOR_PRIMARY = '#16191E';